import { SendIframeMessageEventData, SendIframeMessageEventSchema } from "./schema";
import { IS_EMBEDDED } from "./utils";

export function dispatchIframeEvent(data: SendIframeMessageEventData) {
    if (!IS_EMBEDDED) return;

    try {
        SendIframeMessageEventSchema.parse(data);
        window.parent.postMessage(data, '*');
    } catch (error) {
        console.error(`[iframe]: Failed sending iframe event with action "${data.action}"`);
    }
}
